import React, {
  FC, useEffect, useState,
} from 'react';
import cls from 'classnames';
import {
  useLocation,
} from 'react-router-dom';

import { SidebarContextProvider } from '@alpha/ui-lib/ui/layout/PersistentSidebar/';

import useSwitchAccount from '../../../hooks/useSwitchAccount';
import { Footer } from '../Footer';
import Header from '../Header/Header';
import { Sidebar } from '../Sidebar';

import { IPageProps } from './Page.interfaces';
import useStyles from './Page.styles';

export const Page: FC<IPageProps> = ({ children }: IPageProps) => {
  const classes = useStyles();
  const location = useLocation();
  const [viewablePages, setViewablePages] = useState<string[]>([]);

  const {
    currentPagesConfiguration,
    getPortalPagesConfiguration,
    getAccountConfigIsMoneyDisabled,
  } = useSwitchAccount();

  const onSidebarLoaded = (): void => {
    (async () => {
      try {
        await getPortalPagesConfiguration();
        setViewablePages(currentPagesConfiguration()?.viewablePages as string[]);
        await getAccountConfigIsMoneyDisabled();
      } catch (e) {
        console.error(e);
      }
    })();
  };

  const isDashboard = location.pathname.includes('dashboard');
  const newStyle = isDashboard ? classes.newMainDashboard : classes.newMain;

  useEffect(() => {
    onSidebarLoaded();
  }, []);

  return (
    <SidebarContextProvider onOpen={onSidebarLoaded}>
      <Header />
      <Sidebar
        viewableTabs={viewablePages}
      />

      <main className={cls(
        newStyle,
        classes.newSideBar,
        false ? classes.expired : '',
      )}
      >
        {children}
      </main>
      <Footer />
    </SidebarContextProvider>
  );
};

export default Page;
